import React from 'react';
import PropTypes from 'prop-types';

// Sub-section heading + optional × Clear chip on the right.
// Shared by every section under V3OfferModifiersCard so the chrome stays
// identical across sub-sections.
const SubsectionHeader = ({ title, hasContent, onClear }) => (
  <div className="deal-terms-card__subsection-header">
    <span className="deal-terms-card__subsection-title">{title}</span>
    <span className="deal-terms-card__subsection-spacer" />
    {hasContent && (
      <button
        type="button"
        className="deal-terms-card__clear-chip"
        onClick={onClear}
        aria-label={`Clear ${title}`}
        data-testid={`clear-${title.toLowerCase().replace(/\s+/g, '-')}`}
      >
        <span className="deal-terms-card__clear-chip-x" aria-hidden="true">×</span>
        Clear
      </button>
    )}
  </div>
);

SubsectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  hasContent: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default SubsectionHeader;
